"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnsNS = void 0;
var SnsNS;
(function (SnsNS) {
    let EventCompressionType;
    (function (EventCompressionType) {
        EventCompressionType["NONE"] = "none";
        EventCompressionType["KEYS"] = "keys";
        EventCompressionType["GZIP"] = "gzip";
    })(EventCompressionType = SnsNS.EventCompressionType || (SnsNS.EventCompressionType = {}));
})(SnsNS = exports.SnsNS || (exports.SnsNS = {}));
//# sourceMappingURL=sns.types.js.map